import { render, staticRenderFns } from "./DescriptionLaporanComponent.vue?vue&type=template&id=65a7f6d1"
import script from "./DescriptionLaporanComponent.vue?vue&type=script&lang=js"
export * from "./DescriptionLaporanComponent.vue?vue&type=script&lang=js"
import style0 from "./DescriptionLaporanComponent.vue?vue&type=style&index=0&id=65a7f6d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports